import { render, staticRenderFns } from "./ChangePermission.vue?vue&type=template&id=2d4493b9&scoped=true&"
import script from "./ChangePermission.vue?vue&type=script&lang=js&"
export * from "./ChangePermission.vue?vue&type=script&lang=js&"
import style0 from "./ChangePermission.vue?vue&type=style&index=0&id=2d4493b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4493b9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCheckbox,VIcon})
